module.exports = __webpack_public_path__ + "img/logo-long.4b219785.png";